import { atom } from 'nanostores'

export const $subscribedView = atom<{
  isOpen: boolean
  isTrial: boolean
}>({ isOpen: false, isTrial: false })
